<div class="logo" [class.hide-small-logo]="hasStepper">
  <a href="https://www.visana.ch" tabindex="-1"><img alt="Logo" src="assets/img/visana_logo_no_claim.svg" /></a>
</div>
<dap-lib-stepper *ngIf="hasStepper && (steps$ | async) as steps" [steps]="steps"></dap-lib-stepper>

<ng-container *ngIf="hasBasket && (hasPersons$ | async)">
  <div *dapLibShowForBreakpoint="'for-Small-Down'" class="basket-spacer"></div>
  <ssc-basket [activePersonId$]="activePersonId$"></ssc-basket>
</ng-container>
